import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Reset window scroll to top on new-page navigation (PUSH / REPLACE),
 * but preserve the previous scroll on browser Back (POP) so users
 * return to where they were.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType === "POP") return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, navType]);
  return null;
}
